// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__xD4c8","cell":"ColumnAccessor_cell__OScVQ","firstCellAccent":"ColumnAccessor_firstCellAccent__1Oubo"};